import { MailInfo } from './../../model/mail-info.model';
import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-edit-mail-info-button',
  templateUrl: './edit-mail-info-button.component.html',
  styleUrls: ['./edit-mail-info-button.component.scss']
})
export class EditMailInfoButtonComponent implements OnInit {
  @Input() mailInfo: MailInfo;
  @Output() correctMail = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {}

  correctMailInfo(): void {
    this.correctMail.emit(this.mailInfo.ai_mail_id);
  }
}
